// extracted by mini-css-extract-plugin
module.exports = {"faxDetails":"styles_faxDetails__1JOCf","detailsBorder":"styles_detailsBorder__1SiAe"};